import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { defaultTheme } from '@ds/react-components';
import GlobalStyles from 'styles/GlobalStyles';
import App from './App.js';
import configureStore from './configureStore';

const store = configureStore();

ReactDOM.render(
  <MuiThemeProvider theme={defaultTheme}>
    <GlobalStyles />
    <Provider store={store}>
      <App />
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
);
